import React from "react";
import RailsFormTextInput from "../ReusableComponents/RailsFormInputs/RailsFormTextInput"
import RailsFormSelectInput from "../ReusableComponents/RailsFormInputs/RailsFormSelectInput";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEDITOR_CONFIG from '../shared/constants/ckeditor_config';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';

export default class KeenformPostSubmitEditor extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      keenform: props.keenform,
      showCKEditor: true
    }
  }
  /**
   * expected props
   * form_rule
   *  -model name
   *  -attribute name
   *  -value
   */
  updateKeenformAttribute = (attributeName, attributeVal) => {
    let newKeenformState = Object.assign({}, this.state.keenform);
    console.log(attributeName, attributeVal);
    newKeenformState[attributeName] = attributeVal;
    this.setState({
      keenform: newKeenformState
    });
  }

  toggleCKEditor = () => {
    console.log("toggle something");
    this.setState({
      showCKEditor: !this.state.showCKEditor
    });
  }

  showRedirectUrlInput = () => {
    return <RailsFormTextInput
      label="Redirect URL"
      model_name="keenform"
      attribute_name="redirect_url" 
      value={this.state.keenform.redirect_url || ""}
      onChangeEvent={this.updateKeenformAttribute} />;
  }

  showSubmissionPageContentEditor = () => {
    return (<div className="form-group row">
      <label className="col-sm-4 col-form-label">Submission Page Content:</label>
      <div className="col-sm-8">
      { this.state.showCKEditor ?
        <CKEditor
        editor={ ClassicEditor }
        config={ CKEDITOR_CONFIG }
        data={this.state.keenform.submission_page_content}
        onChange={ ( event, editor ) => {
          const data = editor.getData();
          this.updateKeenformAttribute("submission_page_content", data);
        } } /> : undefined }
      <textarea 
        name="keenform[submission_page_content]"
        className={`form-control ${this.state.showCKEditor ? 'd-none' : ''}`}
        value={this.state.keenform.submission_page_content}
        onChange={ (event) => {this.updateKeenformAttribute("submission_page_content", event.target.value)}}
        />
      <button type="button" className="btn btn-info" onClick={() =>{this.toggleCKEditor()}}>{this.state.showCKEditor ? <span>Show HTML</span> : <span>Show Editor</span>}</button>
      </div>
    </div>);
  }

  render (){
    const modelName = "keenform",
    keenform = this.state.keenform;
    return (
      <React.Fragment>
        <div className="form-group row">
          <div className="col-sm-4 text-right">
            <label 
              id="kf-send-email-label"
              className="col-form-label text-right">Send email on submission?</label>
          </div>
          <div className="col-sm-8">
            <BootstrapSwitchButton 
              onlabel='Send email' 
              offlabel='No email'
              onstyle='primary'
              offstyle='light'
              width='200'
              size="lg"
              onChange={(checked) => {
                let keenformState = {
                  ...this.state.keenform
                };
                keenformState.send_email = checked;
                this.setState({keenform: keenformState});
              }}
              checked={ this.state.keenform.send_email } />
            <input 
              type="hidden" 
              name="keenform[send_email]"
              value={( this.state.keenform.send_email ? 1 : 0 )} />
          </div>
        </div>
        <RailsFormSelectInput
          label="Post Submit Action"
          model_name={modelName}
          attribute_name="post_submit_action"
          value={this.state.keenform.post_submit_action}
          options={this.props.keenform_postsubmit_action_types}
          onChangeEvent={this.updateKeenformAttribute} />
        { keenform.post_submit_action === "display_values" ? 
        <div>"Display values" is ideal for testing, to verify the values that have been submitted</div> : undefined }
        { keenform.post_submit_action === "redirect" ? 
        this.showRedirectUrlInput() : undefined }
        { keenform.post_submit_action === "show_page_content" ? 
        this.showSubmissionPageContentEditor() : undefined }
        <button className="btn btn-primary">Submit</button>
      </React.Fragment>
    );
  }
}